<template>
  <div class="mailing-practice-container">
    <w-nav-bar nav_title="投递简历" @mobileLeftBtn="pageBack"></w-nav-bar>
    <div class="practice-content">
      <h3>个人信息</h3>
      <div class="practice-date flex-between" @click="selectBirthday">
        <span class="practice-label">出生年月</span>
        <span class="practice-label label-date"
              :class="{'color-': payload.birthday}">{{ payload.birthday || '选择日期' }}</span>
      </div>
    </div>
    <div class="practice-content">
      <h3>实习时间</h3>
      <div class="practice-info">
        <div class="practice-date flex-between date-item">
          <span class="practice-label">每周可实习天数</span>
          <div class="practice-label flex-start">
            <i class="iconfont iconminus-circle" :class="{'icon-disabled': payload.intern_frequency === 1}"
               @click="changePracticeCount('subtraction')"></i>
            <span class="practice-count">{{ payload.intern_frequency }}</span>
            <i class="iconfont iconplus-circle" :class="{'icon-disabled': payload.intern_frequency === 5}"
               @click="changePracticeCount('add')"></i>
          </div>
        </div>
        <div class="practice-date flex-between">
          <span>可实习月份</span>
          <div class="practice-label flex-start">
            <span class="practice-time" :class="{'color-': payload.onboard_at}" @click="changeMonth">{{ payload.onboard_at || '开始月份' }}</span>
            <span class="practice-count">至</span>
            <span class="practice-time" :class="{'color-': payload.end_at}" @click="changeMonth">{{ payload.end_at || '结束月份' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer practice-footer flex-center" @click="practiceMailing">
      <button class="theme-button">立即投递</button>
    </div>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'

	const moment = require('moment')

	export default {
		name: 'mailing-practice',
		data () {
			return {
				cascadePicker: null,
				payload: {
					intern_frequency: 1,
					onboard_at: '',
					end_at: '',
					birthday: ''
				}
			}
		},
		mounted () {
			this.initPracticeMonth()
		},
		computed: {},
		watch: {},
		components: {
			WNavBar
		},
		methods: {
			pageBack () {
				this.$router.back()
			},
			async practiceMailing () {
				let { cvToken, jobToken } = this.$route.query
				let { birthday, onboard_at, end_at, intern_frequency } = this.payload
				const [ basic, intention ] = await Promise.all([
					this.$api.online.createBasicInfo({ birthday: birthday + '-01' }),
					this.$api.intention.updateIntentions({
						intern_frequency,
						onboard_at: `${ onboard_at }-01`,
						end_at: `${ end_at }-01`
					})
				])
				if (basic.code === 1000 && intention.code === 1000) {
					let res = await this.$api.jobs.jobDelivery(jobToken, { cv_token: cvToken })
					if (res.code === 1000) this.$router.back()
				}
			},
			// 修改实习天数
			changePracticeCount (type) {
				if (type === 'add' && this.payload.intern_frequency < 5) {
					this.payload.intern_frequency += 1
				} else if (type === 'subtraction' && this.payload.intern_frequency > 1) {
					this.payload.intern_frequency -= 1
				}
			},
			// 选择实习天数
			changeMonth () {
				this.cascadePicker.show()
			},
			// 选择出生年月
			selectBirthday () {
				this.$createDatePicker({
					min: new Date('1950-01'),
					max: new Date(moment().format('YYYY-MM')),
					startColumn: 'year',
					columnCount: 2,
					value: this.payload.birthday ? new Date(this.payload.birthday) : new Date(`${ moment().subtract(22, 'year').format('YYYY') }-06`),
					format: {
						month: 'MM',
						date: 'DD'
					},
					onSelect: val => {
						this.payload.birthday = moment(val).format('YYYY-MM')
					},
				}).show()
			},
			// 初始化选择实习月份的数据
			initPracticeMonth () {
				let monthsData = Array.from({ length: 12 }, (item, index) => {
					return {
						value: moment().add(index, 'month').format('YYYY-MM'),
						text: moment().add(index, 'month').format('YYYY-MM'),
						children: [
							{
								text: '至',
								children: Array.from({ length: 13 }, (v, num) => {
									return {
										value: moment().add(index + num + 1, 'month').format('YYYY-MM'),
										text: moment().add(index + num + 1, 'month').format('YYYY-MM'),
									}
								})
							}
						]
					}
				})
				this.cascadePicker = this.$createCascadePicker({
					data: monthsData,
					selectedIndex: [ 0, 0, 3 ],
					onSelect: (val) => {
						this.payload.onboard_at = val[0]
						this.payload.end_at = val[2]
					},
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/global/variable';
  @import '../../assets/scss/global/mixin';
  .mailing-practice-container {
    @include mobile-container(44px, 1px);
    min-height: $screen-height;
    .practice-content {
      padding: 24px 16px;
      .practice-info {
        border: 1px solid #ececec;
        border-radius: 4px;
        margin-top: 10px;
        padding: 0 16px;
        .practice-date {
          border: none;
          margin: 0;
          border-radius: 0;
          padding: 18px 0;
          &:first-child {
            border-bottom: 1px solid #ECECEC;
          }
        }
      }
      .practice-date {
        padding: 18px 16px;
        border: 1px solid #ECECEC;
        border-radius: 4px;
        margin-top: 10px;
        .practice-label {
          color: $color-title;
          .practice-count {
            margin: 0 16px;
            min-width: 14px;
            text-align: center;
          }
          .practice-time {
            color: #BCBCBC;
          }
          .iconfont {
            color: #404040;
            font-size: 18px;
          }
          .icon-disabled {
            color: #9C9C9C;
          }
        }
        .label-date {
          color: #BCBCBC;
        }
        .color- {
          color: $color-title !important;
        }
      }
      .date-item {
        border-bottom: 1px solid #f4f4f4;
      }
    }
    .practice-footer {
      width: 100vw;
      @include ipx-content-bottom(20px);
      button {
        width: calc(100vw - 32px);
        height: 45px;
        border-radius: 4px;
        color: #F8F9FD;
        font-size: $font-size-medium-x;
      }
    }
  }
</style>
